import { BaseFetch } from "../main-model";
export default class BuildingModel extends BaseFetch {
  getBuildingBy = (data) =>
    this.authFetch({
      url: "building/getBuildingBy",
      method: "POST",
      body: data,
    });
  getBuildingById = (data) =>
    this.authFetch({
      url: "building/getBuildingById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertBuilding = (data) =>
    this.authFetch({
      url: "building/insertBuilding",
      method: "POST",
       body: JSON.stringify(data),
    });
  updateBuildingById = (data) =>
    this.authUpload({
      url: "building/updateBuildingById",
      method: "POST",
      body: data,
    });
  deleteBuildingById = (data) =>
    this.authFetch({
      url: "building/deleteBuildingById",
      method: "POST",
      body: JSON.stringify(data),
    });
  checkBuilding = (data) =>
    this.authFetch({
      url: "building/checkBuilding",
      method: "POST",
      body: JSON.stringify(data),
    });
}
